import {FC} from "react";
import {Navigate, Route, Routes} from "react-router";
import {HomePageRoute} from "../pages/HomePage";
import {ErrorPageRoute} from "../pages/ErrorPage";
import {PageRoute} from "../types/PageRoute";

export const routes: PageRoute[] = [
	HomePageRoute,
];

export const RootRouter: FC = () => {
	return (
		<Routes>
			{routes.map((pageRoute) => (
				<Route key={pageRoute.route} path={pageRoute.route} element={pageRoute.component} />
			))}
			<Route path="/index" element={<Navigate to="/" replace />} />
			<Route path="*" element={ErrorPageRoute.component} />
		</Routes>
	);
};
